import React from 'react';
import camelcase from 'camelcase-es5';

import Box from '../Box/Box';
import { PrimaryButton, SecondaryButton } from '../Button';

import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

import TModalFooter, { TButtonConfig } from './@types/TModalFooter';

// Configuration constant - change this to modify the maximum button limit
const MAX_BUTTONS = 2;

const ModalFooter = ({
  buttons = [],
  buttonsAlignmentDesktop = 'rightAligned',
  buttonsAlignmentMobile = 'stacked',
}: TModalFooter) => {
  // Validate button count
  if (buttons.length > MAX_BUTTONS) {
    // eslint-disable-next-line no-console
    console.log(
      `ModalFooter: Maximum of ${MAX_BUTTONS} buttons allowed. Only the first ${MAX_BUTTONS} buttons will be rendered.`,
    );
  }

  // Get buttons to render (max limit)
  const buttonsToRender = buttons.slice(0, MAX_BUTTONS);

  if (buttonsToRender.length === 0) {
    return null;
  }

  const conditionalProps = filterConditionalKeyValues({
    modifiers: [camelcase(`desktop_${buttonsAlignmentDesktop}`), camelcase(`mobile_${buttonsAlignmentMobile}`)],
  });

  const renderButton = (buttonConfig: TButtonConfig, index: number) => {
    // Handle custom React element
    if ('element' in buttonConfig) {
      return React.cloneElement(buttonConfig.element as React.ReactElement, { key: index });
    }

    // Handle component configuration
    const { component, text, ...restProps } = buttonConfig;

    const buttonProps = {
      children: text,
      ...restProps,
    };

    // Dynamic component rendering based on component string
    switch (component) {
      case 'PrimaryButton':
        return <PrimaryButton key={index} {...buttonProps} />;
      case 'SecondaryButton':
        return <SecondaryButton key={index} {...buttonProps} />;
      default:
        return <SecondaryButton key={index} {...buttonProps} />;
    }
  };

  return (
    <Box as="div" parent="Modal" name="Footer" {...conditionalProps}>
      {buttonsToRender.map((buttonConfig, index) => renderButton(buttonConfig, index))}
    </Box>
  );
};

export default ModalFooter;
